<template>
  <v-card class="card-rounded" flat>
    <v-card-title>
      <h2 class="secondary--text">{{course.group}}</h2>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list two-line dense>

        <v-list-tile
          avatar
          @click="goToLink(item.link)"
          v-for="(item, key) in course.items"
          :key="key"
        >
          <v-list-tile-avatar>
            <v-img contain :src="item.image" />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{item.name}}</v-list-tile-title>
            <v-list-tile-sub-title>{{item.link}}</v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'resource',
  props: ['course'],
  methods: {
    goToLink(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style>
.image {
  flex-wrap: wrap;
  padding: 15px;
}

.image-inner {
  display: flex;
  align-items: center;
  width: 8cm;
  height: 4cm;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
}
.image-wrap .image {
  width: 100%;
  height: 100%;
}
</style>
